/* -----------------Globals--------------- */
import { SectionList } from "react-native";

/* -----------------UI--------------- */
import { Chip, List, RadioButton } from "react-native-paper";

import type { SvgProps } from "react-native-svg";
import { useAppTheme } from "../../useAppTheme";
import useBreakpoints from "../../useBreakpoints";
import Box from "../Box";
/* -----------------Child components--------------- */
import { CustomListSubheader } from "../CustomListSubheader";
import EmptyState from "../EmptyView";

interface Section {
	title: string;
	data: {
		name: string;
		id: string;
		description?: string;
	}[];
}

interface Props {
	sections: Section[];
	handleSelectItem: (itemId: string) => void;
	selectedItemId?: string;
	emptySearchResultSvg?: React.FC<SvgProps>;
	handleClearSearch: () => void;
	initSelectedItemId?: string;
	showCurrentExamChip?: boolean;
}
export const SearchableSectionList = ({
	sections,
	handleSelectItem,
	selectedItemId,
	emptySearchResultSvg,
	handleClearSearch,
	initSelectedItemId,
	showCurrentExamChip = true,
}: Props) => {
	const theme = useAppTheme();
	const { xsUp } = useBreakpoints();

	const showSectionHeader = sections.length > 1;
	return (
		<SectionList
			sections={sections}
			showsVerticalScrollIndicator={true}
			ListEmptyComponent={
				<EmptyState
					title="No exams found"
					subtitle="Try adjusting your filters or search query"
					image={emptySearchResultSvg}
					cta="Clear search"
					handleAction={handleClearSearch}
				/>
			}
			contentContainerStyle={{
				minHeight: "100%",
				paddingBottom: xsUp ? 48 : 184,
			}}
			keyExtractor={(item) => item.id.toString()}
			renderItem={({ item }) => (
				<>
					<List.Item
						onPress={() => handleSelectItem(item.id)}
						title={item.name}
						description={item.description}
						titleNumberOfLines={2}
						left={(p) => (
							<List.Icon
								{...p}
								icon={() => (
									<RadioButton.Android
										status={
											selectedItemId === item.id ? "checked" : "unchecked"
										}
										onPress={() => handleSelectItem(item.id)}
										value={selectedItemId?.toString() ?? ""}
									/>
								)}
							/>
						)}
					/>
					{showCurrentExamChip && initSelectedItemId === item.id && xsUp && (
						<Box position="absolute" right={16} top={10}>
							<Chip selected compact>
								Current Exam
							</Chip>
						</Box>
					)}
				</>
			)}
			renderSectionHeader={({ section: { title } }) =>
				showSectionHeader ? (
					<CustomListSubheader
						enableGutters={false}
						style={{
							paddingLeft: 16,
							backgroundColor: theme.colors.background,
						}}
					>
						{title}
					</CustomListSubheader>
				) : null
			}
		/>
	);
};
